import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { StoreService } from '../services/store.service';
import { CartFlowService } from '../services/cart-flow.service';
import { CartFlowStages, AppRoutes } from '@ciptech/constants'

@Injectable({ providedIn: 'root' })
export class CartFlowGuard implements CanActivate {
	constructor(
		private store: StoreService,
		private cartFlowService: CartFlowService,
		private router: Router
	) { }

	canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | UrlTree {
		const stage = route.data?.cartStage as CartFlowStages;
		if (!stage) {
			return this.router.parseUrl(AppRoutes.HOME);
		}
		const validation = this.cartFlowService.validateStage(this.store.cart, stage);
		if (validation.valid)
			return true;
		return this.router.parseUrl(validation.redirect!);
	}
}
